import React from 'react';
import { ClbButton } from '@celebration/design-system/dist/lib/button';
import { createComponent } from '@lit-labs/react';

export default createComponent({
    react: React,
    elementClass: ClbButton,
    tagName: ClbButton.tagName,
    events: ClbButton.events,
});
